/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import ScrollUpButton from "./scrollUpButton"
import "./layout.css"

const Layout = ({ children, rootPage, windowWidth }) => {

  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata?.title || `Title`} rootPage = {rootPage} windowWidth = {windowWidth} />
      <div style={layoutWrapperStyle} >
        <div style={layoutStyle} >
          <main>{children}</main>
        </div>
      </div>
      <ScrollUpButton />
    </>
  )
}

const layoutWrapperStyle = {
    width: '100%'
}

const layoutStyle = {
  margin: `0 auto`,
  maxWidth: `100%`,
  background: 'var(--cream)',
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
